import React from 'react';

/** Small shared pieces for the admin console. */

export async function adminFetch(path, { method = 'GET', body } = {}) {
    const res = await fetch(path, {
        method,
        credentials: 'include',
        headers: body ? { 'Content-Type': 'application/json' } : undefined,
        body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Something went wrong.');
    return data;
}

const MIN = 60 * 1000, HOUR = 60 * MIN, DAY = 24 * HOUR;

/** "just now", "5m ago", "3h ago", "4d ago", then a date */
export function ago(iso) {
    if (!iso) return 'never';
    const d = Date.now() - new Date(iso).getTime();
    if (d < 0) return 'just now';
    if (d < MIN) return 'just now';
    if (d < HOUR) return `${Math.floor(d / MIN)}m ago`;
    if (d < DAY) return `${Math.floor(d / HOUR)}h ago`;
    if (d < 30 * DAY) return `${Math.floor(d / DAY)}d ago`;
    return shortDate(iso);
}

/** "in 5h", "in 3d" */
export function until(iso) {
    const d = new Date(iso).getTime() - Date.now();
    if (d <= MIN) return 'any minute';
    if (d < HOUR) return `in ${Math.round(d / MIN)}m`;
    if (d < DAY) return `in ${Math.round(d / HOUR)}h`;
    return `in ${Math.round(d / DAY)}d`;
}

export function uptime(s) {
    if (s == null) return 'unknown';
    const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    return d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export const shortDate = (iso) => new Date(iso).toLocaleDateString([], { month: 'short', day: 'numeric', year: new Date(iso).getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined });
export const clock = (iso) => new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
export const dateTime = (iso) => `${shortDate(iso)}, ${clock(iso)}`;

/** Status word for a health state */
export const STATE_WORD = { ok: 'Healthy', warn: 'Check', bad: 'Down', unknown: 'Unknown' };

export function Dot({ state = 'ok', pulse = false }) {
    return <span className={`adm-dot ${state}${pulse ? ' pulse' : ''}`} aria-hidden="true" />;
}

const TRADE_STATUS = {
    pending: 'Offer', accepted: 'Accepted', processing: 'In progress',
    finished: 'Finished', cancelled: 'Cancelled',
};
export function StatusChip({ status }) {
    return <span className={`adm-chip st-${status}`}>{TRADE_STATUS[status] || status}</span>;
}
